window.checkResponse = function(data, status) {
  if (!status) return {type: 'danger', message: "Unknown Error"};
  var msg = {type: 'success', message: "Success"};
  if (data === null) return msg;
  if (data instanceof Document) {
    var $data = window.jquery(data);
    if ($data.find('error').length) {
      var code = $data.find('code').text();
      var message = $data.find('error message').text();
      msg = {type: 'danger', message: code + ': ' + message};
    }
  } else if (typeof data === 'object') {
    if (data.result && data.result.error) {
      msg = {type: 'danger', message: data.result.error.code + ': ' + data.result.error.message};
    } else {
      var err = data.code && data.message;
      if (err) msg = {type: 'danger', message: data.code + ': ' + data.message};
      if (window.RECIPE && data.objectType === 'KalturaUiConfListResponse') {
        data.objects = data.objects.filter(function(uiConf) {
          return (uiConf.html5Url || '').indexOf('/v2') !== -1 || uiConf.objType === KalturaUiConfObjType.KRECORD;
        });
        if (!data.objects.length) return {type: 'danger', message: 'No v2 uiConfs found.'}
      }
    }
  }
  if (msg.message.indexOf('SERVICE_FORBIDDEN') !== -1) {
    // FIXME: show login modal
  }
  return msg;
}




// WEBPACK FOOTER //
// ../../../../../root/api-docs/assets/js/check-response.js